import React, { useState } from "react";
import styled from "styled-components";
import { colors } from "../../../utils/theme";
import Swal from "sweetalert2";

import Select from "../../FormComponents/PatiendContactComponet/FormInput/Select";
import Input from "../../FormComponents/PatiendContactComponet/FormInput/Input";

import { useNavigate } from "react-router-dom";
import {
  IPatientInformation,
  IPatientLoginAppointment,
  IPatientOrderServiceContex,
} from "../../../interfaces/Patient";
import { useDataContex } from "../../../hooks/Context/PatientProvider";

const ContainerOrder = styled.div`
  .paginator {
    padding: 1rem;
    display: flex;
    background-color: ${colors.gris};
    border-radius: 10px 10px 0 0;
    margin-bottom: 1rem;
    justify-content: space-between;
    align-items: center;
    @media (max-width: 550px) {
      flex-direction: column;
    }
  }

  .title1 {
    color: ${colors.primary};
    font-size: 1.5rem;
    font-weight: bold;
    margin: 0 auto;
    @media (max-width: 768px) {
      font-size: 1.5rem;
    }
    @media (max-width: 500px) {
      text-align: center;
    }
  }
`;

const ContainerFormOrder = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 20px;
  justify-content: center;
`;

const FormInputOrder = styled.div`
  width: 40%;
  display: flex;
  gap: 20px;
  flex-direction: column;
  @media (max-width: 1024px) {
    width: 80%;
  }

  label {
    color: ${colors.third};
    font-weight: 600;
    width: 70%;
    @media (max-width: 500px) {
      width: 100%;
    }
  }

  option {
    color: ${colors.fifth};
  }

  .entidad {
    width: 70%;
    align-self: flex-end;
    @media (max-width: 1024px) {
      align-self: normal;
      width: 100%;
    }
  }

  .area {
    width: 70%;
    @media (max-width: 1024px) {
      width: 100%;
    }
  }
`;

const ContainerButton = styled.div`
  display: flex;
  justify-content: center;
  margin-top: 2rem;
  .button {
    width: 20%;
    display: block;
    padding: 0.7rem;
    border: none;
    border-radius: 30px;
    color: ${colors.blanco};
    background-color: ${colors.azul};
    margin-bottom: 2rem;
    font-weight: bold;
    text-decoration: none;
    text-align: center;
    @media (max-width: 1440px) {
      width: 30%;
    }
    @media (max-width: 1024px) {
      width: 40%;
    }
    @media (max-width: 768px) {
      width: 50%;
    }
    @media (max-width: 600px) {
      width: 80%;
    }
    @media (max-width: 350px) {
      font-size: 0.8rem;
    }
  }
`;

const UserLoginContinuity = () => {
  const { setPatientInfoContinuidadContex } = useDataContex();
  const { setPatientInformationContext } = useDataContex();
  const navigate = useNavigate();

  const [UseformDataPatient, setUseFormDataPatient] =
    useState<IPatientLoginAppointment>({
      TypeDocument: { field: "", isValid: null },
      DocumentNumber: { field: "", isValid: null },
    });

  const allFieldsValid = Object.values(UseformDataPatient).every(
    (item) => item.field
  );

  const onSutmit = (e) => {
    e.preventDefault();

    if (allFieldsValid) {
      async function postContinuitySesion(typeID, IdNumber) {
        const url = "/apihub/legacy/Service/Agenda/ContinuidadDePacientes";
        const requestBody = {
          tipoDocumento: typeID,
          numeroDocumento: IdNumber,
        };

        try {
          const response = await fetch(url, {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify(requestBody),
          });

          const data = await response.json();

          if (!response.ok) {
            var error = new Error(
              `HTTP error! status: ${response.status}`
            ) as any;
            error.data = data;
            throw error;
          }
          return data;
        } catch (error) {
          throw error;
        }
      }

      const originalString = UseformDataPatient.DocumentNumber.field;
      const splitString = originalString.split("-");
      const typeId = splitString[0];
      const IdNumber = UseformDataPatient.TypeDocument.field;

      postContinuitySesion(typeId, IdNumber)
        .then((data) => {
          if (data && data.data) {
            const dataService = data;
            const PatientOrder: IPatientOrderServiceContex = {
              name: dataService.data.name,
              numeroDocumento: dataService.data.numeroDocumento,
              tipoDocumento: dataService.data.tipoDocumento,
              fechaNacimiento: dataService.data.fechaNacimiento,
              email: dataService.data.email,
              telefono: dataService.data.telefono,
              orders: dataService.data.orders
            };

            const patientInformation: IPatientInformation = {
              email: dataService.data.email,
              fechaNacimiento: dataService.data.fechaNacimiento,
              name: dataService.data.name,
              numeroDocumento: dataService.data.numeroDocumento,
              telefono: dataService.data.telefono,
              tipoDocumento: dataService.data.tipoDocumento,
            };

            Swal.fire({
              title: "¡Formulario exitoso!",
              text: "Campos correctos",
              icon: "success",
              timer: 1500,
              showConfirmButton: false,
            });
            setTimeout(() => {
              setPatientInformationContext(patientInformation!);
              setPatientInfoContinuidadContex(PatientOrder);
              navigate("/OrderContinuidad");
            }, 1500);
          } else {
            Swal.fire({
              title: "¡Error en el formulario!",
              icon: "error",
              timer: 1500,
              html: "error al traer la informacion del paciente",
              showConfirmButton: false,
            });
          }
        })
        .catch((error) => {
          console.log("error", error);
          var messege = error.data.errors.join("</br>");
          Swal.fire({
            title: "¡Error en el formulario!",
            icon: "error",
            timer: 1500,
            html: messege,
            showConfirmButton: false,
          });
        });
    } else {
      const updatedUseFormDataPatient = { ...UseformDataPatient };

      for (const key in updatedUseFormDataPatient) {
        updatedUseFormDataPatient[key].Isvalid =
          updatedUseFormDataPatient[key].Isvalid === true;
      }

      setUseFormDataPatient(updatedUseFormDataPatient);

      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Rellene todos lo campos faltante!",
        confirmButtonText: "Cerrar",
        confirmButtonColor: "#ec2323",
      });
    }
  };

  const RegularExpressionsForm = {
    name: /^[a-zA-ZÀ-ÿ\s]{1,40}$/, // Letras y espacios, pueden llevar acentos.
    password: /^.{4,12}$/, // 4 a 12 digitos.
    email: /^[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+\.[a-zA-Z0-9-.]+$/,
    phone: /^\d{10}$/, // 7 a 14 numeros.
    id: /^\d{1,15}$/,
    dayMonth: /^(0[1-9]|[12][0-9]|3[01])$/,
    year: /^\d{4}$/,
    textArea: /^.{0,150}$/,
    fieldEmty: /^.{5,50}$/,
  };

  const TypeDocumentNumber = [
    { value: "CC", label: "CÉDULA DE CIUDADANÍA" },
    { value: "TI", label: "TARJETA DE IDENTIDAD" },
    { value: "CE", label: "CÉDULA DE EXTRANJERÍA" },
    { value: "PA", label: "PASAPORTE" },
    { value: "RC", label: "REGISTRO CIVIL" },
  ];

  const [expId, setExpId] = useState(RegularExpressionsForm.id);

  const handleRestriction = (e) => {
    if (e === "PA-PASAPORTE" || e === "CE-CÉDULA DE EXTRANJERÍA") {
      setExpId(/^[a-zA-Z0-9\-\/]+$/);
    } else {
      setExpId(/^\d{1,15}$/);
    }
  };
  return (
    <ContainerOrder>
      <div className="paginator">
        <span className="title1">INGRESO DE PACIENTE CONTINUIDAD</span>
      </div>

      <form onSubmit={onSutmit}>
        <ContainerFormOrder>
          <FormInputOrder>
            <label className="entidad">TIPO DE DOCUMENTO</label>
            <div className="entidad">
              <Select
                state={UseformDataPatient.DocumentNumber}
                changeState={(newState) =>
                  setUseFormDataPatient({
                    ...UseformDataPatient,
                    DocumentNumber: newState,
                  })
                }
                placeholder="Seleccione..."
                options={TypeDocumentNumber}
                nameOption="areasAfectadas"
                legendError="Eliga Su Tipo de Documento"
              />
            </div>
          </FormInputOrder>

          <FormInputOrder>
            <label className="area">NÚMERO DE IDENTIFICACIÓN</label>
            <div className="area">
              <Input
                state={UseformDataPatient.TypeDocument}
                changeState={(newState) => {
                  setUseFormDataPatient({
                    ...UseformDataPatient,
                    TypeDocument: newState,
                  });
                  handleRestriction(UseformDataPatient.DocumentNumber.field);
                }}
                placeholder="No. ID SIN PUNTOS"
                type="text"
                legendError="Digite Su Numero de Identificación"
                expressionRegular={expId}
              />
            </div>
          </FormInputOrder>
        </ContainerFormOrder>

        <ContainerButton>
          <button className="button" type="submit">
            CONTINUAR AGENDAMIENTO
          </button>
        </ContainerButton>
      </form>
    </ContainerOrder>
  );
};

export default UserLoginContinuity;
